<project-navigation
  headerTitle="projectNavigation.title.select_project_group"
  headerText=""
  actionButtonLabel="projectNavigation.label.submit"
  [model]="model"
  [submitEnabled]="submitEnabled"
  [visibleFeatures]="{
    compositeCheckBox: false,
    pinnedProjects: false,
    recentlyUsedProjects: false,
    history: false,
    projectActionsMenu: false,
    projectGroupContextMenu: false,
    newConfigurationGroupBtn: true,
    newFolderBtn: true,
    dialogSearch: true,
    tabs: false,
    breadcrumbs: true,
  }"
  (submitEnabledChanged)="updateSubmitEnabled()"
  (actionBtnClick)="submit()"
  (cancel)="cancel()"
></project-navigation>
